export const CloseIcon = () => {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="4.30094"
        y1="4.72848"
        x2="12.7862"
        y2="13.2138"
        stroke="currentColor"
      />
      <line
        x1="4.24618"
        y1="13.2168"
        x2="12.7315"
        y2="4.73148"
        stroke="currentColor"
      />
    </svg>
  )
}
